const FADE_WIDTH = 40;

const update = (el) => {
	const maxScroll = el.scrollWidth - el.clientWidth;

	el.style.setProperty('--fade-scroll-left', `${Math.max(0, Math.min(el.scrollLeft, FADE_WIDTH))}px`);
	el.style.setProperty('--fade-scroll-right', `${Math.max(0, Math.min(maxScroll - el.scrollLeft, FADE_WIDTH))}px`);
};

document.querySelectorAll('.fade-scroll-x').forEach((el) => {
	el.addEventListener('scroll', () => update(el), { passive: true });
	new ResizeObserver(() => update(el)).observe(el);
});
